import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=3a4935f0"
import script from "./upload.vue?vue&type=script&lang=ts"
export * from "./upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports